import * as Sentry from "@sentry/react";

import React from 'react';
import ReactDOM from 'react-dom/client';

import 'bootstrap/dist/css/bootstrap.min.css';
// Design tokens load before any app CSS so other stylesheets can
// reference var(--bg), var(--accent), etc. Loaded once globally; the
// `.surface-marketing` wrapper class re-scopes the cascade for
// marketing routes. See docs/dashboard-redesign/phase-0-audit.md.
import './styles/tokens.css';
import './index.css';

import reportWebVitals from './reportWebVitals';

import App from "./App";
import { isStaging } from "./config/environment";

// Belt-and-braces noindex for staging. The staging CloudFront distribution
// already sends X-Robots-Tag and serves a Disallow-all robots.txt; this
// covers crawlers that execute JS and read the meta tag. See ADR 0001.
if (isStaging) {
    const robots = document.createElement("meta");
    robots.name = "robots";
    robots.content = "noindex, nofollow";
    document.head.appendChild(robots);
}

Sentry.init({
    dsn: "https://6262d379a674faf401d85d7c8128ecec@o4509114069417984.ingest.us.sentry.io/4509115145125888",
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.browserProfilingIntegration(),
    ],
    environment: isStaging ? 'staging' : (process.env.NODE_ENV === 'production' ? 'production' : 'development'),
    tracesSampleRate: 1.0,
    tracePropagationTargets: ["localhost", /^https:\/\/pokerledger\.club/],
    profilesSampleRate: 1.0,
});

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
